<template>
    <v-container fluid>
        <h2 style="color:rgb(124,131,124)">Informações</h2>
        <br>

        <v-text-field
            v-if="ticketId != null && ticketId != 0"
            v-model="codeId"
            label="Número"
            outlined
            clearable
            style="border-radius:12px"
            :disabled="true"
        ></v-text-field>
        
        <v-text-field
            v-if="ticketId != null && ticketId != 0"
            v-model="creationDate"
            :label="loginData.userData.userType == 1 ? 'Data Criação' : 'Data Abertura'"
            outlined
            clearable
            style="border-radius:12px"
            :disabled="true"
        ></v-text-field>

        <v-text-field
            v-if="ticketId != null && ticketId != 0"
            v-model="createdBy"
            :label="loginData.userData.userType == 1 ? 'Criado Por' : 'Aberto Por'"
            outlined
            clearable
            style="border-radius:12px"
            :disabled="true"
        ></v-text-field>

        <simple-select 
            v-if="ticketId != null && ticketId != 0"
            :model="operator.operatorSelected"
            :label="loginData.userData.userType == 1 ? 'Operador Responsável' : 'Ultimo Operador'"
            :items="operator.listOperators"
            v-on:valueChanged="changeOperator"
            :disabled="operator.disabled"
        ></simple-select>
                   
        <simple-select 
            v-if="loginData.userData.userType == 1"
            :model="client.clientSelected"
            label="Cliente"
            :items="client.listClients"
            v-on:valueChanged="changeClient"
            :disabled="client.disabled"
        ></simple-select>

        <simple-select 
            v-if="loginData.userData.userType == 1"
            :model="contact.contactSelected"
            label="Contato Cliente"
            :items="contact.listContacts"
            v-on:valueChanged="changeContact"
            :disabled="contact.disabled"
        ></simple-select>

        <simple-select 
            :model="priority.prioritySelected"
            label="Prioridade"
            :items="priority.listPriorities"
            v-on:valueChanged="changePriority"
            :disabled="priority.disabled"
        ></simple-select>

        <simple-select 
            :model="area.areaSelected"
            label="Área"
            :items="area.listAreas"
            v-on:valueChanged="changeArea"
            :disabled="area.disabled"
        ></simple-select>

        <simple-select 
            :model="category.categorySelected"
            label="Categoria"
            :items="category.listCategories"
            v-on:valueChanged="changeCategory"
            :disabled="category.disabled"
        ></simple-select>

        <simple-select 
            :model="subject.subjectSelected"
            label="Assunto"
            :items="subject.listSubjects"
            v-on:valueChanged="changeSubject"
            :disabled="subject.disabled"
        ></simple-select>

        <v-checkbox
            style="margin-top: 0px;"
            v-if="loginData.userData.userType == 2 && ticketId == 0"
            v-model="notFind"
            label="Não encontrei o assunto nessa lista!"
        ></v-checkbox>

        <simple-select 
            v-if="loginData.userData.userType == 1 || (loginData.userData.userType == 2 && ticketId != null && ticketId != 0)"
            :model="status.statusSelected"
            label="Status"
            :items="status.listStatus"
            v-on:valueChanged="changeStatus"
            :disabled="status.disabled"
        ></simple-select>

        <simple-select 
            v-if="loginData.userData.userType == 1"
            :model="level.levelSelected"
            label="Nível de Suporte"
            :items="level.listLevels"
            v-on:valueChanged="changeLevel"
            :disabled="level.disabled"
        ></simple-select>

        <h3 v-if="sla != ''" style="color:rgb(124,131,124)">SLA: {{sla}}</h3>
        <br v-if="sla != ''">

        <v-datetime-picker 
            v-if="!noExpectedDate.on && loginData.userData.userType == 1"
            dateFormat="dd/MM/yyyy" 
            clearText="Limpar" 
            :textFieldProps=textFieldProps 
            :datePickerProps=datePickerProps 
            :timePickerProps=timePickerProps 
            label="Data Prevista" 
            :datetime="expectedDateTime.datetime"
            v-model="expectedDateTime.datetime"
            :disabled="expectedDateTime.disabled"> 
        </v-datetime-picker>

        <v-row v-if="loginData.userData.userType == 1"> 
            <v-col
                class="d-flex"
                cols="12"
                sm="12"
            >
                <span>Sem data prevista</span>
                <v-switch
                    v-model="noExpectedDate.on"
                    :disabled="noExpectedDate.disabled"
                    color="orange"
                    style="margin-top: 0px; padding-top: 0px; margin-left: 20px"
                ></v-switch>
            </v-col>
        </v-row>

        <v-text-field
            v-if="finished"
            v-model="totalService"
            label="Tempo de Duração"
            outlined
            clearable
            style="border-radius:12px"
            :disabled="true"
        ></v-text-field>

        <v-text-field
            v-if="showFinishDate"
            v-model="endDate"
            :label="loginData.userData.userType == 1 ? 'Data de Finalização' : 'Data de Fechamento'"
            outlined
            clearable
            style="border-radius:12px"
            :disabled="true"
        ></v-text-field>

        <v-text-field
            v-if="finished"
            v-model="finishingUser"
            label="Finalizado Por"
            outlined
            clearable
            style="border-radius:12px"
            :disabled="true"
        ></v-text-field>

        <h2 v-if="client.clientSelected != null" style="color:rgb(124,131,124)">Equipamento</h2>
        <span v-if="product.selected != null && client.clientSelected != null">{{product.selected.subtitles[1].value}}</span>
        <p v-if="client.clientSelected != null" @click="sheet = true">{{product.selected != null && product.selected.subtitles[1].value != "Nenhum Equipamento!" ? "Trocar" : "Selecione"}} o equipamento</p>

        <h2 style="color:rgb(124,131,124)">Anexos</h2>
        <span v-if="files.length == 0">Nenhum anexo</span>
        <br>

        <v-row>
            <div class="files"> 
                <div v-for="(file, index) in files" :key="index">
                    <v-card 
                        class="d-flex justify-center"
                        style="padding:20px; margin-right: 10px"
                        outlined
                        v-if="file.attachmentId == null">
                        <v-img height="80" width="80"
                            :src="getImage(file)">
                        </v-img>
                        <v-card-text>
                            {{file.name.length > 20 ? `${file.name.substring(0, 17)}...` : file.name}}
                        </v-card-text>
                    </v-card>
                    <v-card 
                        class="d-flex justify-center"
                        style="padding:20px; margin-right: 10px;"                        
                        outlined
                        v-if="file.attachmentId != null"
                        @click="downloadFile(file)">
                        <v-img height="80" width="80"
                            :src="getImage(file)">
                        </v-img>
                        <v-card-text>
                            {{file.fileName.length > 20 ? `${file.fileName.substring(0, 17)}...` : file.fileName}}
                        </v-card-text>
                    </v-card>  
                </div>
            </div>
        </v-row>

        <v-row justify="center" style="margin-top:50px">
            <v-file-input
                accept="image/*;capture=camera"
                label="File input"
                multiple
                v-model="files"
                v-show="false"
                ref="inputUpload"
            ></v-file-input>
        </v-row>
        <v-row :style="getStyle()" align="center" justify="center" v-if="ticketId == 0">
            <v-btn
                color="primary"
                style="color:white"
                @click="sendFile"
            >
                Selecione os arquivos
                <v-icon
                    right
                    dark
                >
                    mdi-cloud-upload
                </v-icon>
            </v-btn>
        </v-row>
        <v-textarea
            outlined
            rows="3"
            name="input-7-4"
            label="Descrição"
            value=""
            v-model="description.text"
            style="border-radius:12px"
            :disabled="description.disabled"
        ></v-textarea>
        <br>
        <br>
        <br v-if="ticketId != null && ticketId != 0">
        <v-btn
            v-if="ticketId == 0 || options.length > 0"
            color="primary"
            dark
            fab
            fixed
            bottom
            right
            :class="ticketId == 0 ? `btnPlusNew` : `btnPlus`"
            @click="clickPlus"
        >
            <v-icon v-if="ticketId == 0">
                mdi-content-save
            </v-icon>
            <v-icon v-if="ticketId != null && ticketId != 0">
                mdi-plus
            </v-icon>
        </v-btn>
        <template>
            <div class="text-center">
                <v-bottom-sheet v-model="sheet" scrollable>
                    <v-card>
                        <v-card-title>Selecione o Equipamento</v-card-title>
                        <v-text-field
                            style="margin-left:10px; margin-right:10px"
                            label="Filtro"
                            solo
                            v-model="product.filter"
                            @keyup="changeFilter"
                            autocomplete="off"
                        ></v-text-field>
                        <v-divider></v-divider>
                        <v-card-text style="height: 500px;">
                            <div v-for="(product, index) in product.listProducts" :key="index">
                                <div @click="changeProduct(product)">
                                    <sigCardInformation
                                        :subtitles="product.subtitles"
                                        :componentCurrent="component"
                                        :classCard="'pa-0'"
                                        :styleCard="
                                            'margin:10px'
                                        "
                                        :classSubtitle="'text-body-1'"
                                    ></sigCardInformation>
                                </div>
                            </div>
                            <div class="text-center">
                                <v-pagination
                                    v-model="pagination.page"
                                    :length="pagination.length"
                                    prev-icon="mdi-menu-left"
                                    next-icon="mdi-menu-right"
                                    @input="changePage"
                                ></v-pagination>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-bottom-sheet>
                <v-bottom-sheet v-model="sheetOptions">
                    <v-list>
                        <v-list-item
                            v-for="(option, index) in options"
                            :key="index"
                            @click="clickOption(option)"
                        >
                            <v-list-item-avatar>
                                <v-icon
                                    color="primary"
                                    medium
                                >
                                    {{ option.icon }}
                                </v-icon>
                            </v-list-item-avatar>
                            <v-list-item-title>{{ option.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-bottom-sheet>
            </div>
        </template>

        <v-dialog
            v-model="dialog.show"
            max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    {{dialog.title}}
                </v-card-title>

                <v-card-text>
                    {{dialog.message}}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        color="green darken-1"
                        text
                        @click="dialog.show = false"
                    >
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialogSuccess.show"
            max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    {{dialogSuccess.title}}
                </v-card-title>

                <v-card-text>
                    {{dialogSuccess.message}}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                        color="green darken-1"
                        text
                        @click="clickCloseDialogSuccess"
                    >
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialogChangeProduct"
            max-width="290"
        >
            <v-card>
                <v-card-title class="headline">
                    Trocar Equipamento
                </v-card-title>

                <v-card-text>
                    Confirma troca do equipamento?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="black"
                        text
                        @click="dialogChangeProduct = false"
                    >
                        Não
                    </v-btn>

                    <v-btn
                        color="black"
                        text
                        @click="confirmChangeProduct"
                    >
                        Sim
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            persistent
            v-model="dialogAction.show"
        >   
            <v-card style="padding: 15px;">
                <div v-if="dialogAction.action == 'edit'">
                    <h2 class="text-center">Editar {{label.name}}</h2>
                    <br>
                    <simple-select 
                        :model="client.clientSelected"
                        label="Cliente"
                        :items="client.listClients"
                        v-on:valueChanged="changeClient"
                    ></simple-select>
        
                    <simple-select 
                        :model="contact.contactSelected"
                        label="Contato Cliente"
                        :items="contact.listContacts"
                        v-on:valueChanged="changeContact"
                    ></simple-select>

                    <simple-select 
                        :model="priority.prioritySelected"
                        label="Prioridade"
                        :items="priority.listPriorities"
                        v-on:valueChanged="changePriority"
                    ></simple-select>

                    <simple-select 
                        :model="area.areaSelected"
                        label="Área"
                        :items="area.listAreas"
                        v-on:valueChanged="changeArea"
                    ></simple-select>

                    <simple-select 
                        :model="category.categorySelected"
                        label="Categoria"
                        :items="category.listCategories"
                        v-on:valueChanged="changeCategory"
                    ></simple-select>

                    <simple-select 
                        :model="subject.subjectSelected"
                        label="Assunto"
                        :items="subject.listSubjects"
                        v-on:valueChanged="changeSubject"
                    ></simple-select>

                    <h3 style="color:rgb(124,131,124)">SLA: {{sla}}</h3>
                    <br>

                    <v-datetime-picker 
                        v-if="!noExpectedDate.on"
                        dateFormat="dd/MM/yyyy" 
                        clearText="Limpar" 
                        :textFieldProps=textFieldProps 
                        :datePickerProps=datePickerProps 
                        :timePickerProps=timePickerProps 
                        label="Data Prevista" 
                        :datetime="expectedDateTime.datetime"
                        v-model="expectedDateTime.datetime"> 
                    </v-datetime-picker>

                    <v-row> 
                        <v-col
                            class="d-flex"
                            cols="12"
                            sm="12"
                        >
                            <v-switch
                                label="Sem Data Prevista"
                                v-model="noExpectedDate.on"
                                color="orange"
                                style="margin-top: 0px; padding-top: 0px; margin-left: 20px"
                            ></v-switch>
                        </v-col>
                    </v-row>

                    <v-textarea
                        outlined
                        rows="3"
                        name="input-7-4"
                        label="Descrição"
                        value=""
                        v-model="description.text"
                        style="border-radius:12px"
                    ></v-textarea>
                </div>

                <div v-if="dialogAction.action == 'changeSupportLevel'">
                    <h2 class="text-center">Alterar Nível de Suporte</h2>
                    <br>
                    <simple-select 
                        :model="level.levelSelected"
                        label="Nível de Suporte"
                        :items="level.listLevels"
                        v-on:valueChanged="changeLevel"
                    ></simple-select>
                </div>

                <div v-if="dialogAction.action == 'forward'">
                    <h2 class="text-center">Encaminhar para:</h2>
                    <br>
                    <v-tabs
                        v-model="tab"
                        centered
                        icons-and-text
                    >
                        <v-tabs-slider></v-tabs-slider>

                        <v-tab href="#tab-1">
                            Área
                            <v-icon>mdi-domain</v-icon>
                        </v-tab>

                        <v-tab href="#tab-2">
                            Operador
                            <v-icon>mdi-account</v-icon>
                        </v-tab>

                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item value="tab-1">
                            <div style="margin-top:15px">
                                <simple-select 
                                    :model="area.areaSelected"
                                    label="Área"
                                    :items="area.listAreas"
                                    v-on:valueChanged="changeArea"
                                ></simple-select>

                                <simple-select 
                                    :model="category.categorySelected"
                                    label="Categoria"
                                    :items="category.listCategories"
                                    v-on:valueChanged="changeCategory"
                                ></simple-select>

                                <simple-select 
                                    :model="subject.subjectSelected"
                                    label="Assunto"
                                    :items="subject.listSubjects"
                                    v-on:valueChanged="changeSubject"
                                ></simple-select>
                            </div>
                        </v-tab-item>
                        <v-tab-item value="tab-2">
                            <div style="margin-top:15px">
                                <simple-select 
                                    :model="operator.operatorSelected"
                                    label="Operador Responsável"
                                    :items="operator.listOperators"
                                    v-on:valueChanged="changeOperator"
                                ></simple-select>
                            </div>
                        </v-tab-item>
                    </v-tabs-items>
                </div>

                <div v-if="dialogAction.action == 'finish'">
                    <h2 class="text-center">Finalizar {{label.name}}</h2>
                    <br>

                    <v-textarea
                        outlined
                        rows="3"
                        name="input-7-4"
                        label="Interação"
                        value=""
                        v-model="finishInteraction"
                        style="border-radius:12px"
                    ></v-textarea>
                </div>

                <div v-if="dialogAction.action == 'downloadFileIos'">
                    <h2 class="text-center">Anexo</h2>
                    <br>

                    <v-text-field
                        v-model="linkDownloadFile"
                        ref="textToCopy"
                        label="Link"
                        outlined
                        style="border-radius:12px"
                        :readonly="true"
                    ></v-text-field>
                </div>

                <v-row justify="center" style="margin-bottom:10px">
                    <v-btn
                        style="margin-right:20px"
                        @click="back"
                    >
                        Voltar
                    </v-btn>
                    <v-btn 
                        v-if="dialogAction.action == 'downloadFileIos'"
                        color="primary"
                        style="color:white"
                        @click="copyText">Copiar</v-btn>
                    <v-btn
                        v-if="dialogAction.action != 'downloadFileIos'"
                        color="primary"
                        style="color:white"
                        @click="save(dialogAction.action)"
                    >
                        Salvar
                    </v-btn>
                </v-row>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import CrudService from '../../../../services/CrudService';
import SimpleSelect from '../../../../components/selects/SimpleSelect';
import CardInformation from "../../../../components/card/CardInformation";
import TextCard from "../../../../components/card/TextCard";
import moment from 'moment';

export default {

    components: {
        "sigCardInformation": CardInformation,
        "simple-select": SimpleSelect
    },

    data: () => ({
        linkDownloadFile: "",
        notFind: false,
        savedNow: false,
        loginData: null,
        label: "",
        finishInteraction: "",
        tab: null,
        endDate: "",
        totalService: "",
        finishingUser: "",
        createdBy: "",
        creationDate: "",
        codeId: "",
        description: {
            text: "",
            disabled: false
        },
        ticketId: null,
        product: {
            listProducts: [],
            listProductsBkp: [],
            listProductsFilter: [],
            filter: "",
            selected: null,
            changeSelected: null
        },
        component: TextCard,
        sheet: false,
        expectedDateTime: {
            datetime: "",
            disabled: false
        },
        noExpectedDate: {
            on: false,
            disabled: false
        },
        client: {
            clientSelected: null,
            listClients: [],
            listClientsAllData: [],
            disabled: false
        },
        contact: {
            contactSelected: null,
            listContacts: [],
            disabled: false
        },
        priority: {
            prioritySelected: null,
            listPriorities: [],
            disabled: false
        },
        area: {
            areaSelected: null,
            listAreas: [],
            disabled: false
        },
        category: {
            categorySelected: null,
            listCategories: [],
            disabled: false
        },
        subject: {
            subjectSelected: null,
            listSubjects: [],
            disabled: false
        },
        status: {
            statusSelected: null,
            listStatus: [
                {text: "AGUARDANDO ATENDIMENTO", value: 10},
                {text: "EM ATENDIMENTO", value: 50}
            ],
            disabled: false
        },
        level: {
            levelSelected: null,
            listLevels: [
                {text: "NIVEL 1", value: 1},
                {text: "NIVEL 2", value: 2},
                {text: "NIVEL 3", value: 3}
            ],
            disabled: false
        },
        operator: {
            operatorSelected: null,
            listOperators: [],
            disabled: false
        },
        files: [],
        dialogChangeProduct: false,
        dialog: {
            show: false,
            title: '',
            message: ''
        },
        dialogSuccess: {
            show: false,
            title: '',
            message: ''
        },
        dialogAction: {
            show: false,
            action: ""
        },
        pagination: {
            length: 0,
            page: 1
        },
        textFieldProps: {
            outlined: true,
            style:"border-radius:12px"
        },
        datePickerProps: {
            locale: "pt-br"
        },
        timePickerProps: {
            format:"24hr"
        },
        sla: "",
        finished: false,
        showFinishDate: false,
        sheetOptions: false,
        options: [],
    }),

    async created(){
        
        this.loginData = JSON.parse(localStorage.getItem("loginData"));

        let canDemands = this.loginData.permissionAndMenu.find(permission => {
            return permission.menuId == 27
        });

        if(!(canDemands != null || this.loginData.userData.userType == 2))
            this.$router.push('menu');
        else{
            this.ticketId = localStorage.getItem("ticketId");
    
            if(this.ticketId == null)
                this.$router.push('listDemmands');
    
            await this.createdFunction();
        }
    },

    methods: {
        async back(){
            document.body.removeAttribute("class","noscroll");
            this.dialogAction.show = false;
            await this.createdFunction();
        },
        
        async createdFunction(){
            let loader = this.$loading.show();

            try
            {
                window.scrollTo(0,0)

                let crudService = new CrudService();

                this.label = this.loginData.labels.find((lbl) => {
                    return lbl.typeLabel == 1
                });
                
                if(this.loginData.userData.userType == 1){
                    
                    let resultClients = await crudService.get(`comboDemands/getComboClients/${this.loginData.userData.personId}`, this.loginData.token);
                    if(resultClients.status == 200){
                        this.client.listClients = resultClients.data.map(client => {
                            return {
                                text: client.clientName,
                                value: client.clientId 
                            }
                        });
                        this.client.listClientsAllData = resultClients.data;
                    }
                    else if(resultClients.status == 401){
                        localStorage.removeItem("loginData");
                        this.$router.push({name: 'Login', params: {logout: true}});
                    }
                    else if(resultClients.status == 400){
                        this.dialog.title = "Erro";
                        this.dialog.message = resultClients.data[0];
                        this.dialog.show = true;
                    }
                    else if(resultClients.status != 204){
                        this.dialog.title = "Erro";
                        this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                        this.dialog.show = true;
                    }
                }
                else{
                    await this.changeClient({
                        value: this.loginData.userData.clientHelpDeskId
                    });
                }
                
                let resultPriority = await crudService.get(`comboDemands/getComboPriority/${this.loginData.userData.signatureId}`, this.loginData.token);
                if(resultPriority.status == 200){
                    this.priority.listPriorities = resultPriority.data.map(priority => {
                        return {
                            text: priority.description,
                            value: priority.priorityId 
                        }
                    })
                }
                else if(resultPriority.status == 401){
                    localStorage.removeItem("loginData");
                    this.$router.push({name: 'Login', params: {logout: true}});
                }
                else if(resultPriority.status == 400){
                    this.dialog.title = "Erro";
                    this.dialog.message = resultPriority.data[0];
                    this.dialog.show = true;
                }
                else if(resultPriority.status != 204){
                    this.dialog.title = "Erro";
                    this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                    this.dialog.show = true;
                }

                if(this.ticketId != null && this.ticketId != 0){
                    this.options = [];

                    let getDemands = await crudService.get(`demands/${this.ticketId}`, this.loginData.token);

                    if(getDemands.status == 200){
                        this.operator.disabled = true;
                        this.client.disabled = true;
                        this.contact.disabled = true;
                        this.priority.disabled = true;
                        this.area.disabled = true;
                        this.category.disabled = true;
                        this.subject.disabled = true;
                        this.status.disabled = true;
                        this.level.disabled = true;
                        this.expectedDateTime.disabled = true;
                        this.noExpectedDate.disabled = true;
                        this.description.disabled = true;
                        
                        this.codeId = getDemands.data.codeId;
                        this.creationDate = moment(getDemands.data.creationDate).format("DD/MM/YYYY HH:mm");
                        this.createdBy = getDemands.data.createdBy;
                        
                        if(this.loginData.userData.userType == 1){
                            await this.changeClient(this.client.listClients.find(obj => {
                                return obj.value == getDemands.data.clientId
                            }));
                        }
                        this.changeContact(this.contact.listContacts.find(obj => {
                            return obj.value == getDemands.data.contactId
                        }));

                        this.changePriority(this.priority.listPriorities.find(obj => {
                            return obj.value == getDemands.data.priorityId
                        }));

                        await this.changeArea(this.area.listAreas.find(obj => {
                            return obj.value == getDemands.data.areaId;
                        }));

                        await this.changeCategory(this.category.listCategories.find(obj => {
                            return obj.value == getDemands.data.categoryId;
                        }));

                        await this.changeSubject(this.subject.listSubjects.find(obj => {
                            return obj.value == getDemands.data.subjectId;
                        }));

                        this.status.listStatus = [...this.status.listStatus, {text: "FINALIZADO PELO CLIENTE", value: 60}, {text: "FINALIZADO PELO OPERADOR", value: 70}]

                        this.changeStatus(this.status.listStatus.find(obj => {
                            return obj.value == getDemands.data.statusId;
                        }));

                        if(getDemands.data.supportLevelId == 0){
                            this.level.listLevels = [{text: "NENHUM", value: 0}, ...this.level.listLevels]
                        }

                        this.changeLevel(this.level.listLevels.find(obj => {
                            return obj.value == getDemands.data.supportLevelId;
                        }));

                        this.expectedDateTime.datetime = moment(getDemands.data.forecast).format("DD/MM/YYYY HH:mm");
                        
                        window.setTimeout(() => {
                            this.noExpectedDate.on = getDemands.data.noExpectedDate;
                        }, 0);

                        let labelEquipment = "Nenhum Equipamento!";
                        if(getDemands.data.internalCodeEquipment != null && getDemands.data.internalCodeEquipment != "" && getDemands.data.equipment != null && getDemands.data.equipment != ""){
                            labelEquipment = `${getDemands.data.internalCodeEquipment} - ${getDemands.data.equipment}`;
                        }
                        else if((getDemands.data.internalCodeEquipment == null || getDemands.data.internalCodeEquipment == "") && (getDemands.data.equipment != null && getDemands.data.equipment != "")){
                            labelEquipment = `${getDemands.data.equipment}`;
                        }
                        else if((getDemands.data.internalCodeEquipment != null && getDemands.data.internalCodeEquipment != "") && (getDemands.data.equipment == null || getDemands.data.equipment == "")){
                            labelEquipment = `${getDemands.data.internalCodeEquipment}`;
                        }
                        
                        this.product.selected = {};
                        this.product.selected.subtitles = [];
                        this.product.selected.subtitles[1] = {};
                        this.product.selected.subtitles[1].value = labelEquipment;

                        this.files = getDemands.data.listAttachments;

                        if(this.ticketId != null && this.ticketId != 0 && (getDemands.data.statusId == 70 || getDemands.data.statusId == 60)){
                            if(this.loginData.userData.userType == 1){
                                this.finishingUser = getDemands.data.finishingUser;
                                this.totalService = getDemands.data.totalService;
                                this.finished = true;
                            }
                            this.endDate = moment(getDemands.data.endDate).format("DD/MM/YYYY HH:mm");
                            this.showFinishDate = true;
                        }

                        this.description.text = getDemands.data.description;

                        let result = await crudService.get(`comboDemands/getComboOperators/${getDemands.data.areaId}`, this.loginData.token);
                        
                        if(result.status == 200){
                            this.operator.listOperators = result.data.map(operator => {
                                return {
                                    text: operator.operatorName,
                                    value: operator.operatorId 
                                }
                            });
                            
                            this.operator.listOperators = [
                                {
                                    text: "NENHUM OPERADOR RESPONSÁVEL",
                                    value: null
                                },
                                ...this.operator.listOperators
                            ];

                            this.changeOperator(this.operator.listOperators.find((op) => {
                                return op.value == getDemands.data.responsibleOperatorId;
                            }));
                        }
                        else if(result.status == 401){
                            localStorage.removeItem("loginData");
                            this.$router.push({name: 'Login', params: {logout: true}});
                        }
                        else if(result.status == 400){
                            this.dialog.title = "Erro";
                            this.dialog.message = result.data[0];
                            this.dialog.show = true;
                        }
                        else if(result.status != 204){
                            this.dialog.title = "Erro";
                            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                            this.dialog.show = true;
                        }

                        this.loginData.permissionAndMenu.forEach(menu => {
                            if((this.loginData.userData.userType == 1 && menu.menuId == 36) || this.loginData.userData.userType == 2){
                                if(getDemands.data.statusId != 30 && getDemands.data.statusId != 40 && getDemands.data.statusId != 60 && getDemands.data.statusId != 70){
                                    this.options.push({ icon: 'mdi-power', title: `Finalizar ${this.label.name}`, go: "finish" });
                                }
                            }
                            else if((this.loginData.userData.userType == 1 && menu.menuId == 37)){
                                if(getDemands.data.statusId == 60 || getDemands.data.statusId == 70){
                                    this.options.push({ icon: 'mdi-power', title: `Reabrir ${this.label.name}`, go: "reopen" });
                                }
                            }
                            else if(this.loginData.userData.userType == 1 && menu.menuId == 40){
                                if(getDemands.data.statusId != 30 && getDemands.data.statusId != 40 && getDemands.data.statusId != 60 && getDemands.data.statusId != 70){
                                    this.options.push({ icon: 'mdi-share', title: `Encaminhar ${this.label.name}`, go: "forward" });
                                }
                            }
                            else if(this.loginData.userData.userType == 1 && menu.menuId == 41){
                                if(getDemands.data.statusId != 30 && getDemands.data.statusId != 40 && getDemands.data.statusId != 60 && getDemands.data.statusId != 70){
                                    this.options.push({ icon: 'mdi-account-switch', title: `Alterar Nível de Suporte`, go: "changeSupportLevel" });
                                }
                            }
                            else if(this.loginData.userData.userType == 1 && menu.menuId == 44){
                                if(getDemands.data.statusId != 30 && getDemands.data.statusId != 40 && getDemands.data.statusId != 60 && getDemands.data.statusId != 70){
                                    this.options.push({ icon: 'mdi-pencil', title: `Editar ${this.label.name}`, go: "edit" });
                                }
                            }
                        });

                        if(this.loginData.userData.userType == 2){
                            if(getDemands.data.statusId != 30 && getDemands.data.statusId != 40 && getDemands.data.statusId != 60 && getDemands.data.statusId != 70){
                                this.options.push({ icon: 'mdi-power', title: `Finalizar ${this.label.name}`, go: "finish" });
                            }
                        }
                    }
                    else if(getDemands.status == 401){
                        localStorage.removeItem("loginData");
                        this.$router.push({name: 'Login', params: {logout: true}});
                    }
                    else if(getDemands.status == 400){
                        this.dialog.title = "Erro";
                        this.dialog.message = getDemands.data[0];
                        this.dialog.show = true;
                    }
                    else if(getDemands.status != 204){
                        this.dialog.title = "Erro";
                        this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                        this.dialog.show = true;
                    }
                }
                else{
                    let productId = this.$route.params.productId;
                    if(productId != null){
                        let resultProduct = await crudService.get(`products?signatureId=${this.loginData.userData.signatureId}&internalCode=${productId}&productsOrder=${this.loginData.productsOrder == null ? false : this.loginData.productsOrder}`, this.loginData.token);
                
                        if(resultProduct.status == 200){
                            await this.changeClient(this.client.listClients.find(obj => {
                                return obj.value == resultProduct.data.clientId
                            }));
                            let product = this.product.listProducts.find(pro => {
                                return pro.productId == resultProduct.data.productId
                            });
                            this.changeProduct(product);
                        }
                        else if(resultProduct.status == 204){
                            this.dialog.title = "Erro";
                            this.dialog.message = "Produto não cadastrado. Favor contatar a equipe de suporte ou tentar novamente.";
                            this.dialog.show = true;
                        }
                        else if(resultProduct.status == 401){
                            localStorage.removeItem("loginData");
                            this.$router.push({name: 'Login', params: {logout: true}}); 
                        }
                        else if(resultProduct.status == 400){
                            this.dialog.title = "Erro";
                            this.dialog.message = resultProduct.data[0];
                            this.dialog.show = true;
                        }
                        else if(resultProduct.status != 204){
                            this.dialog.title = "Erro";
                            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                            this.dialog.show = true;
                        }
                    }
                }

                loader.hide();
            }
            catch
            {
                loader.hide();
                this.dialog.title = "Erro";
                this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
                this.dialog.show = true;
            }            
        },

        getImage(file){
            let arrayName = file.attachmentId == null ? file.name.split('.') : file.fileName.split('.');
            let iconName = arrayName[arrayName.length-1];
            iconName = iconName.toLowerCase();

            if(iconName == "csv"){
                return `img/csv.png`;
            }
            else if(iconName == "doc" || iconName == "docx"){
                return `img/doc.png`;
            }
            else if(iconName == "exe"){
                return `img/exe.png`;
            }
            else if(iconName == "jpg" || iconName == "jpeg"){
                return `img/jpg.png`;
            }
            else if(iconName == "mp3"){
                return `img/mp3.png`;
            }
            else if(iconName == "iso" ){
                return `img/iso.png`;
            }
            else if(iconName == "mp4"){
                return `img/mp4.png`;
            }
            else if(iconName == "pdf"){
                return `img/pdf.png`;
            }
            else if(iconName == "png"){
                return `img/png.png`;
            }
            else if(iconName == "ppt" || iconName == "pptx"){
                return `img/ppt.png`;
            }
            else if(iconName == "txt"){
                return `img/txt.png`;
            }
            else if(iconName == "xls" || iconName == "xlsx"){
                return `img/xls.png`;
            }
            else if(iconName == "xml"){
                return `img/xml.png`;
            }
            else if(iconName == "zip" || iconName == "7z"){
                return `img/zip.png`;
            }
            else{
                return `img/documento.png`;
            }
        },
        sendFile(){
            this.$refs.inputUpload.$refs.input.click();
        },

        async changeClient(client){
            if(typeof client === 'object')
            {
                let loader = this.$loading.show();

                try
                {
                    this.client.clientSelected = client;

                    let clientInList = this.client.listClientsAllData.find((cli) => {
                        return cli.clientId == client.value;
                    });
                    
                    if(client.value != 0){
                        let crudService = new CrudService();
                        let resultAreas;
                        
                        if(this.loginData.userData.userType == 1){
                            let resultContacts = await crudService.get(`comboDemands/getComboContact/${clientInList.clientHelpDeskId}`, this.loginData.token);
                            
                            if(resultContacts.status == 200){
                                this.contact.listContacts = resultContacts.data.map(contact => {
                                    return {
                                        text: contact.contactName,
                                        value: contact.contactId
                                    }
                                })
                            }
                            else if(resultContacts.status == 401){
                                localStorage.removeItem("loginData");
                                this.$router.push({name: 'Login', params: {logout: true}}); 
                            }
                            else if(resultContacts.status == 400){
                                this.dialog.title = "Erro";
                                this.dialog.message = resultContacts.data[0];
                                this.dialog.show = true;
                            }
                            else if(resultContacts.status != 204){
                                this.dialog.title = "Erro";
                                this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                                this.dialog.show = true;
                            }

                            resultAreas = await crudService.get(`comboDemands/getComboArea?clientHelpDeskId=${clientInList.clientHelpDeskId}&PersonId=${this.loginData.userData.personId}&UserType=${this.loginData.userData.userType}`, this.loginData.token);
                        }
                        else{
                            resultAreas = await crudService.get(`comboDemands/getComboArea?clientHelpDeskId=${this.loginData.userData.clientHelpDeskId}&PersonId=${this.loginData.userData.personId}&UserType=${this.loginData.userData.userType}`, this.loginData.token);
                        }

                        if(resultAreas.status == 200){
                            this.area.listAreas = resultAreas.data.map(area => {
                                return {
                                    text: area.areaName,
                                    value: area.areaId
                                }
                            })
                        }
                        else if(resultAreas.status == 401){
                            localStorage.removeItem("loginData");
                            this.$router.push({name: 'Login', params: {logout: true}}); 
                        }
                        else if(resultAreas.status == 400){
                            this.dialog.title = "Erro";
                            this.dialog.message = resultAreas.data[0];
                            this.dialog.show = true;
                        }
                        else if(resultAreas.status != 204){
                            this.dialog.title = "Erro";
                            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                            this.dialog.show = true;
                        }

                        let resultProducts;
                        
                        if(this.loginData.userData.userType == 1){
                            resultProducts = await crudService.get(`comboDemands/getComboProduct?clientId=${client.value}&productsOrder=${this.loginData.productsOrder == null ? false : this.loginData.productsOrder}`, this.loginData.token);
                        }
                        else{
                            resultProducts = await crudService.get(`comboDemands/getComboProduct?clientId=${this.loginData.userData.clientId}&productsOrder=${this.loginData.productsOrder == null ? false : this.loginData.productsOrder}`, this.loginData.token);
                        }
                        
                        if(resultProducts.status == 200){
                            this.product.listProductsBkp = resultProducts.data;
                            this.pagination.length = Math.ceil(resultProducts.data.length / 50);
                            
                            for(let i = 0; i < (resultProducts.data.length > 50 ? 50 : resultProducts.data.length); i++){
                                this.product.listProducts.push({
                                    subtitles: [
                                        {key: "Código Interno:", value: resultProducts.data[i].internalCode},
                                        {key: "Descrição:", value: resultProducts.data[i].productName},
                                    ],
                                    productId: resultProducts.data[i].productId
                                })
                            }
                        }
                        else if(resultProducts.status == 401){
                            localStorage.removeItem("loginData");
                            this.$router.push({name: 'Login', params: {logout: true}}); 
                        }
                        else if(resultProducts.status == 400){
                            this.dialog.title = "Erro";
                            this.dialog.message = resultProducts.data[0];
                            this.dialog.show = true;
                        }
                        else if(resultProducts.status != 204){
                            this.dialog.title = "Erro";
                            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                            this.dialog.show = true;
                        }
                    }

                    loader.hide();
                }
                catch
                {
                    loader.hide();
                    this.dialog.title = "Erro";
                    this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
                    this.dialog.show = true;
                }
            }
            else{
                this.client.clientSelected = null;
                this.contact.listContacts = [];
                this.area.listAreas = [];
                this.category.listCategories = [];
                this.subject.listSubjects = [];
            }

            this.contact.contactSelected = null;
            this.area.areaSelected = null;
            this.category.categorySelected = null;
            this.subject.subjectSelected = null;
            this.sla = "";
            this.expectedDateTime.datetime = "";
            this.noExpectedDate.on = true;
            window.setTimeout(() => {
                this.noExpectedDate.on = false;
            }, 0);
        },

        changeContact(contact){
            if(typeof contact === 'object')
                this.contact.contactSelected = contact;
            else
                this.contact.contactSelected = null;
        },

        changeOperator(operator){
            if(typeof operator === 'object')
                this.operator.operatorSelected = operator;
            else
                this.operator.operatorSelected = null;
        },
        
        changePriority(priority){
            if(typeof priority === 'object')
                this.priority.prioritySelected = priority;
            else
                this.priority.prioritySelected = null;
        },

        async changeArea(area){
            if(typeof area === 'object'){
                let loader = this.$loading.show();
                
                try
                {
                    this.area.areaSelected = area;

                    let crudService = new CrudService();

                    let resultCategory = await crudService.get(`comboDemands/getComboCategory/${area.value}`, this.loginData.token);
                    
                    if(resultCategory.status == 200){
                        this.category.listCategories = resultCategory.data.map(category => {
                            return {
                                text: category.categoryName,
                                value: category.categoryId
                            }
                        })
                    }
                    else if(resultCategory.status == 401){
                        localStorage.removeItem("loginData");
                        this.$router.push({name: 'Login', params: {logout: true}}); 
                    }
                    else if(resultCategory.status == 400){
                        this.dialog.title = "Erro";
                        this.dialog.message = resultCategory.data[0];
                        this.dialog.show = true;
                    }
                    else if(resultCategory.status != 204){
                        this.dialog.title = "Erro";
                        this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                        this.dialog.show = true;
                    }

                    loader.hide();
                }
                catch
                {
                    loader.hide();
                    this.dialog.title = "Erro";
                    this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
                    this.dialog.show = true;
                }
            }
            else{
                this.area.areaSelected = null;
                this.category.listCategories = [];
                this.subject.listSubjects = [];
            }
            
            this.category.categorySelected = null;
            this.subject.subjectSelected = null;
            this.sla = "";
            this.expectedDateTime.datetime = "";
            this.noExpectedDate.on = true;
            window.setTimeout(() => {
                this.noExpectedDate.on = false;
            }, 0);
        },

        async changeCategory(category){
            if(typeof category === 'object'){
                let loader = this.$loading.show();

                try
                {
                    this.category.categorySelected = category;

                    let crudService = new CrudService();

                    let resultSubject = await crudService.get(`comboDemands/getComboSubject/${category.value}`, this.loginData.token);
                    
                    if(resultSubject.status == 200){
                        this.subject.listSubjects = resultSubject.data.map(subject => {
                            return {
                                text: subject.title,
                                value: subject.subjectId,
                                data: subject
                            }
                        })
                    }
                    else if(resultSubject.status == 401){
                        localStorage.removeItem("loginData");
                        this.$router.push({name: 'Login', params: {logout: true}});
                    }
                    else if(resultSubject.status == 400){
                        this.dialog.title = "Erro";
                        this.dialog.message = resultSubject.data[0];
                        this.dialog.show = true;
                    }
                    else if(resultSubject.status != 204){
                        this.dialog.title = "Erro";
                        this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                        this.dialog.show = true;
                    }
                    
                    loader.hide();
                }
                catch
                {
                    loader.hide();
                    this.dialog.title = "Erro";
                    this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
                    this.dialog.show = true;
                }
            }
            else{
                this.category.categorySelected = null;
                this.subject.listSubjects = [];
            }

            this.subject.subjectSelected = null;
            this.sla = "";
            this.expectedDateTime.datetime = "";
            this.noExpectedDate.on = true;
            window.setTimeout(() => {
                this.noExpectedDate.on = false;
            }, 0);
        },

        changeSubject(subject){
            if(typeof subject === 'object'){
                this.subject.subjectSelected = subject;

                if(subject.data.days > 0){
                    this.sla = subject.data.days == 1 ? `${subject.data.days} dia` : `${subject.data.days} dias`;
                }
                else{
                    this.sla = subject.data.time
                }
                
                this.expectedDateTime.datetime = moment(subject.data.expectedDate).format("DD/MM/YYYY HH:mm");
            }
            else{
                if(this.loginData.userData.userType == 2){
                    this.subject.subjectSelected = {
                        value: null,
                        text: "NÃO DEFINIDO!"
                    };
                }
                else{
                    this.subject.subjectSelected = null;
                }
            }

            this.noExpectedDate.on = true;
            window.setTimeout(() => {
                this.noExpectedDate.on = false;
            }, 0);
        },
        
        changeStatus(status){
            if(typeof status === 'object')
                this.status.statusSelected = status;
            else
                this.status.statusSelected = null;
        },
        
        changeLevel(level){
            if(typeof level === 'object')
                this.level.levelSelected = level;
            else
                this.level.levelSelected = null;
        },
        
        changeProduct(product){
            if(this.ticketId != null && this.ticketId != 0){
                this.product.changeSelected = product;
                this.dialogChangeProduct = true;
            }
            else{
                this.product.selected = product
                this.sheet = false;
            }
        },
        
        changeFilter(){
            this.product.listProductsFilter = this.product.listProductsBkp.filter(obj => {
                if( obj.internalCode.toLowerCase().includes(this.product.filter.toLowerCase()) ||
                    obj.productName.toLowerCase().includes(this.product.filter.toLowerCase())
                ){
                    return true;
                }
            });

            this.product.listProducts = [];

            this.pagination.page = 1;
            this.pagination.length = Math.ceil(this.product.listProductsFilter.length / 50);

            for(let i = 0; i < 50; i++){
                this.product.listProducts.push({
                    subtitles: [
                        {key: "Código Interno:", value: this.product.listProductsFilter[i].internalCode},
                        {key: "Descrição:", value: this.product.listProductsFilter[i].productName},
                    ],
                    productId: this.product.listProductsFilter[i].productId
                })    
            }
        },

        clickCloseDialogSuccess(){
            if(this.savedNow){
                this.savedNow = false;
                this.$router.go();
                this.$loading.show();
            }

            this.dialogSuccess.show = false;
        },
        
        changePage(page) {
            let end = 50 * page;
            let initial = end - 50;
            this.product.listProducts = [];
            
            if(this.product.filter == ""){
                for(let i = initial; i < end; i++){
                    this.product.listProducts.push({
                        subtitles: [
                            {key: "Código Interno:", value: this.product.listProductsBkp[i].internalCode},
                            {key: "Descrição:", value: this.product.listProductsBkp[i].productName},
                        ],
                        productId: this.product.listProductsBkp[i].productId
                    })
                }
            }
            else{
                for(let i = initial; i < end; i++){
                    this.product.listProducts.push({
                        subtitles: [
                            {key: "Código Interno:", value: this.product.listProductsFilter[i].internalCode},
                            {key: "Descrição:", value: this.product.listProductsFilter[i].productName},
                        ],
                        productId: this.product.listProductsFilter[i].productId
                    })
                }
            }
        },
        
        getStyle(){
            if(this.ticketId == 0)
                return "margin-bottom:20px; margin-left:0px";
            else
                return "margin-bottom:60px; margin-left:0px";
        },

        async clickPlus(){
            if(this.ticketId == 0){
                let loader = this.$loading.show();

                try
                {
                    let clientInList = null;

                    if(this.client.clientSelected != null){
                        clientInList = this.client.listClientsAllData.find((cli) => {
                            return cli.clientId == this.client.clientSelected.value;
                        });
                    }

                    let createDemands = {
                        signatureId: this.loginData.userData.signatureId,
                        userHelpDeskId: this.loginData.userData.userHelpDeskId,
                        userType: this.loginData.userData.userType,
                        clientHelpDeskId: this.loginData.userData.userType == 2 ? this.loginData.userData.clientHelpDeskId : clientInList != null ? clientInList.clientHelpDeskId : 0,
                        contactId: this.loginData.userData.userType == 2 ? this.loginData.userData.contactClientHelpDeskId : this.contact.contactSelected != null ? this.contact.contactSelected.value : 0,
                        sectorHelpDeskId: this.area.areaSelected != null ? this.area.areaSelected.value : 0,
                        problemId: this.notFind ? null : this.subject.subjectSelected != null ? this.subject.subjectSelected.value : 0,
                        priorityId: this.priority.prioritySelected != null ? this.priority.prioritySelected.value : 0,
                        categoryId: this.category.categorySelected != null ? this.category.categorySelected.value : 0,
                        currentStatusId: this.status.statusSelected != null ? this.status.statusSelected.value : 0,
                        supportLevel: this.level.levelSelected != null ? this.level.levelSelected.value : 0,
                        forecast: this.noExpectedDate.on ? null : this.expectedDateTime.datetime == "" ? null : moment(this.expectedDateTime.datetime, "DD/MM/YYYY HH:mm").format("YYYY/MM/DD HH:mm"),
                        noExpectedDate: this.noExpectedDate.on,
                        productId: this.product.selected != null ? this.product.selected.productId : null,
                        term: this.label.name,
                        description: this.description.text
                    }

                    let data = new FormData();
                    data.append('Request', JSON.stringify(createDemands));
                    data.append('MaxUpload', this.loginData.maxUpload);
                
                    this.files.forEach((file) => {
                        data.append('Files', file);
                    });
                    
                    let crudService = new CrudService();

                    let result = await crudService.postWithFile(`demands`, data, this.loginData.token);

                    if(result.status == 200){
                        localStorage.setItem("ticketId", result.data.demandsId);

                        if(this.loginData.userData.userType == 2){
                            this.dialogSuccess.title = "Sucesso";
                            this.dialogSuccess.message = `Você criou um novo ${this.label.name} de número: ${result.data.codeId}. Recebemos um email e breve o atenderemos.`;
                            this.dialogSuccess.show = true;
                        }
                        else{
                            this.dialogSuccess.title = "Sucesso";
                            this.dialogSuccess.message = `${this.label.name} ${result.data.codeId} criado com sucesso.`;
                            this.dialogSuccess.show = true;
                        }

                        this.savedNow = true;
                    }
                    else if(result.status == 401){
                        localStorage.removeItem("loginData");
                        this.$router.push({name: 'Login', params: {logout: true}});
                    }
                    else if(result.status == 400){
                        this.dialogSuccess.title = "Erro";
                        this.dialogSuccess.message = result.data[0];
                        this.dialogSuccess.show = true;
                    }
                    else if(result.status != 204){
                        this.dialog.title = "Erro";
                        this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                        this.dialog.show = true;
                    }

                    //await crudService.postWithFile(`demands`, data, "");

                    loader.hide();   
                }
                catch
                {
                    loader.hide();
                    this.dialog.title = "Erro";
                    this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
                    this.dialog.show = true;   
                }
            }
            else{
                this.sheetOptions = true;
            }
        },

        async clickOption(option){
            document.getElementsByTagName("body")[0].className="noscroll";
            this.sheetOptions = false;

            if(option.go == 'reopen'){
                let loader = this.$loading.show();

                try
                {
                    let data = {
                        demandsId: this.ticketId,
                        userHelpDeskId: this.loginData.userData.userHelpDeskId,
                        status: 10,
                        userType: this.loginData.userData.userType,
                        term: this.label.name
                    }
    
                    let crudService = new CrudService();      
                    
                    let result = await crudService.patch(`demands/reopenDemands/${this.ticketId}`, data, this.loginData.token);
            
                    if(result.status == 200){
                        this.dialogSuccess.title = "Sucesso";
                        this.dialogSuccess.message = `${this.label.name} reaberto com sucesso.`;
                        this.dialogSuccess.show = true;
    
                        await this.back();
                    }
                    else if(result.status == 401){
                        localStorage.removeItem("loginData");
                        this.$router.push({name: 'Login', params: {logout: true}});
                    }
                    else if(result.status == 400){
                        this.dialog.title = "Erro";
                        this.dialog.message = result.data[0];
                        this.dialog.show = true;
                    }
                    else if(result.status != 204){
                        this.dialog.title = "Erro";
                        this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                        this.dialog.show = true;
                    }
    
                    loader.hide();   
                }
                catch
                {
                    loader.hide();
                    this.dialog.title = "Erro";
                    this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
                    this.dialog.show = true;
                }
            }
            else{
                this.dialogAction.show = true;

                if(option.go == 'forward'){
                    this.operator.listOperators = this.operator.listOperators.filter(op => {
                        return op.value != null
                    });
                }

                this.dialogAction.action = option.go
            }

        },

        async save(action){
            let loader = this.$loading.show();

            try
            {
                let crudService = new CrudService();

                if(action == 'edit'){
                    let clientInList = this.client.listClientsAllData.find((cli) => {
                        return cli.clientId == this.client.clientSelected.value;
                    });

                    let data = {
                        demandId: this.ticketId,
                        priorityId: this.priority.prioritySelected.value,
                        description: this.description.text,
                        forecast: this.noExpectedDate.on ? null : moment(this.expectedDateTime.datetime, "DD/MM/YYYY HH:mm").format("YYYY/MM/DD HH:mm"),
                        noExpectedDate: this.noExpectedDate.on,
                        clientHelpDeskId: clientInList.clientHelpDeskId,
                        contactId: this.contact.contactSelected.value,
                        sectorHelpDeskId: this.area.areaSelected.value,
                        categoryId: this.category.categorySelected.value,
                        problemId: this.subject.subjectSelected.value
                    }

                    let result = await crudService.patch(`demands/${this.ticketId}`, data, this.loginData.token);

                    if(result.status == 200){
                        this.dialogSuccess.title = "Sucesso";
                        this.dialogSuccess.message = `${this.label.name} alterado com sucesso.`;
                        this.dialogSuccess.show = true;

                        await this.back();
                    }
                    else if(result.status == 401){
                        localStorage.removeItem("loginData");
                        this.$router.push({name: 'Login', params: {logout: true}});
                    }
                    else if(result.status == 400){
                        this.dialog.title = "Erro";
                        this.dialog.message = result.data[0];
                        this.dialog.show = true;
                    }
                    else if(result.status != 204){
                        this.dialog.title = "Erro";
                        this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                        this.dialog.show = true;
                    }
                }
                else if(action == 'changeSupportLevel'){
                    let data = {
                        demandId: this.ticketId,
                        supportLevel: this.level.levelSelected.value
                    }
                    
                    let result = await crudService.patch(`demands/changeSupportLevel/${this.ticketId}`, data, this.loginData.token);

                    if(result.status == 200){
                        this.dialogSuccess.title = "Sucesso";
                        this.dialogSuccess.message = `Nível de suporte alterado com sucesso.`;
                        this.dialogSuccess.show = true;

                        await this.back();
                    }
                    else if(result.status == 401){
                        localStorage.removeItem("loginData");
                        this.$router.push({name: 'Login', params: {logout: true}});
                    }
                    else if(result.status == 400){
                        this.dialog.title = "Erro";
                        this.dialog.message = result.data[0];
                        this.dialog.show = true;
                    }
                    else if(result.status != 204){
                        this.dialog.title = "Erro";
                        this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                        this.dialog.show = true;
                    }
                }
                else if(action == 'forward'){
                    if(this.tab == "tab-1"){
                        let areaObj = this.area.listAreas.find(area => {
                            return area.value === this.area.areaSelected.value;
                        });

                        let data = {
                            demandsId: this.ticketId,
                            areaId: this.area.areaSelected.value,
                            categoryId: this.category.categorySelected.value,
                            subjectId: this.subject.subjectSelected.value,
                            name: areaObj.text,
                            userHelpDeskId: this.loginData.userData.userHelpDeskId,
                            userType: this.loginData.userData.userType,
                            term: this.label.name
                        }

                        let result = await crudService.patch(`demands/forwardDemandsArea/${this.ticketId}`, data, this.loginData.token);

                        if(result.status == 200){
                            this.dialogSuccess.title = "Sucesso";
                            this.dialogSuccess.message = `${this.label.name} encaminhado com sucesso.`;
                            this.dialogSuccess.show = true;

                            await this.back();
                        }
                        else if(result.status == 401){
                            localStorage.removeItem("loginData");
                            this.$router.push({name: 'Login', params: {logout: true}});
                        }
                        else if(result.status == 400){
                            this.dialog.title = "Erro";
                            this.dialog.message = result.data[0];
                            this.dialog.show = true;
                        }
                        else if(result.status != 204){
                            this.dialog.title = "Erro";
                            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                            this.dialog.show = true;
                        }
                    }
                    else{
                        let operatorObj = this.operator.listOperators.find(operator => {
                            return operator.value === this.operator.operatorSelected.value;
                        });

                        let data = {
                            signatureId: this.loginData.userData.signatureId,
                            demandsId: this.ticketId,
                            operatorId: this.operator.operatorSelected.value,
                            name: operatorObj.text,
                            userHelpDeskId: this.loginData.userData.userHelpDeskId,
                            userType: this.loginData.userData.userType,
                            term: this.label.name
                        }
                        
                        let result = await crudService.patch(`demands/forwardDemandsOperator/${this.ticketId}`, data, this.loginData.token);
                        
                        if(result.status == 200){
                            this.dialogSuccess.title = "Sucesso";
                            this.dialogSuccess.message = `${this.label.name} encaminhado com sucesso.`;
                            this.dialogSuccess.show = true;

                            await this.back();
                        }
                        else if(result.status == 401){
                            localStorage.removeItem("loginData");
                            this.$router.push({name: 'Login', params: {logout: true}});
                        }
                        else if(result.status == 400){
                            this.dialog.title = "Erro";
                            this.dialog.message = result.data[0];
                            this.dialog.show = true;
                        }
                        else if(result.status != 204){
                            this.dialog.title = "Erro";
                            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                            this.dialog.show = true;
                        }
                    }
                }
                else if(action == 'finish'){
                    let data = {
                        demandsId: this.ticketId,
                        userHelpDeskId: this.loginData.userData.userHelpDeskId,
                        userType: this.loginData.userData.userType,
                        interaction: this.finishInteraction,
                        term: this.label.name
                    }

                    let result = await crudService.patch(`demands/finishDemands/${this.ticketId}`, data, this.loginData.token);

                    if(result.status == 200){
                        this.dialogSuccess.title = "Sucesso";
                        this.dialogSuccess.message = `${this.label.name} finalizado com sucesso.`;
                        this.dialogSuccess.show = true;

                        await this.back();
                    }
                    else if(result.status == 401){
                        localStorage.removeItem("loginData");
                        this.$router.push({name: 'Login', params: {logout: true}});
                    }
                    else if(result.status == 400){
                        this.dialog.title = "Erro";
                        this.dialog.message = result.data[0];
                        this.dialog.show = true;
                    }
                    else if(result.status != 204){
                        this.dialog.title = "Erro";
                        this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                        this.dialog.show = true;
                    }
                }

                loader.hide();
            }
            catch
            {
                loader.hide();
                this.dialog.title = "Erro";
                this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
                this.dialog.show = true;
            }            
        },

        async confirmChangeProduct(){
            this.dialogChangeProduct = false;

            let loader = this.$loading.show();

            try
            {
                let crudService = new CrudService();

                let result = await crudService.patch(`demands/changeProductDemands/${this.ticketId}/${this.product.changeSelected.productId}`, {}, this.loginData.token);

                if(result.status == 200){
                    this.dialogSuccess.title = "Sucesso";
                    this.dialogSuccess.message = `Equipamento alterado com sucesso.`;
                    this.dialogSuccess.show = true;

                    this.sheet = false;

                    await this.back();
                }
                else if(result.status == 401){
                    localStorage.removeItem("loginData");
                    this.$router.push({name: 'Login', params: {logout: true}});
                }
                else if(result.status == 400){
                    this.dialog.title = "Erro";
                    this.dialog.message = result.data[0];
                    this.dialog.show = true;
                }
                else if(result.status != 204){
                    this.dialog.title = "Erro";
                    this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                    this.dialog.show = true;
                }

                loader.hide();
            }
            catch
            {
                loader.hide();
                this.dialog.title = "Erro";
                this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
                this.dialog.show = true;
            }
        },

        async downloadFile(file){
            let loader = this.$loading.show();

            try
            {
                let crudService = new CrudService();

                let result = await crudService.get(`attachments/fileExists/${file.attachmentId}`, this.loginData.token);

                if(result.status == 200){
                    let chromeAgent = navigator.userAgent.indexOf("Chrome") > -1; 
                    let safariAgent = navigator.userAgent.indexOf("Safari") > -1;

                    if (chromeAgent && safariAgent){
                        await crudService.downloadFile(`attachments?path=${result.data}`, file.fileName, this.loginData.token);
                    }
                    else{
                        this.dialogAction.show = true;
                        this.linkDownloadFile = `https://sig.plataformasig.com.br/sig/api/attachments?path=${result.data}`;
                        this.dialogAction.action = "downloadFileIos";
                    }
                }
                else if(result.status == 401){
                    localStorage.removeItem("loginData");
                    this.$router.push({name: 'Login', params: {logout: true}});
                }
                else if(result.status == 400){
                    this.dialog.title = "Erro";
                    this.dialog.message = result.data[0];
                    this.dialog.show = true;
                }
                else if(result.status != 204){
                    this.dialog.title = "Erro";
                    this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
                    this.dialog.show = true;
                }

                loader.hide();
            }
            catch
            {
                loader.hide();
                this.dialog.title = "Erro";
                this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
                this.dialog.show = true;
            }
        },

        copyText () {
            let textToCopy = this.$refs.textToCopy.$el.querySelector('input')
            textToCopy.select()
            document.execCommand("copy");
        }
    }
}
</script>
<style>
.files {
    display: flex;
    overflow-x: auto;
    margin-left: 10px;
    margin-right: 10px;
}
.files::-webkit-scrollbar {
    display: none;
}
.noscroll{
    position: fixed;
    overflow-x: hidden;
    overflow-y: hidden;
    width: 100%;
}
.btnPlus {
    margin-bottom:50px;
}
.btnPlusNew {
    margin-bottom:0px;
}
/* iphone X , XS, 11 Pro, 12 Mini */
@media only screen and (min-width: 375px) and (max-height: 812px) and (-webkit-device-pixel-ratio: 3) { 
    .btnPlus {
        margin-bottom:80px;
    }
    .btnPlusNew {
        margin-bottom:0px;
    }
}

/* iphone 12, 12 Pro */
@media only screen and (min-width: 390px) and (max-height: 844px) and (-webkit-device-pixel-ratio: 3) {
    .btnPlus {
        margin-bottom:80px;
    }
    .btnPlusNew {
        margin-bottom:0px;
    }
}

/* iphone XR, 11 */
@media only screen and (min-width : 414px) and (max-height : 896px) and (-webkit-device-pixel-ratio : 2) { 
    .btnPlus {
        margin-bottom:80px;
    }
    .btnPlusNew {
        margin-bottom:0px;
    }
}
    
/* iphone XS Max, 11 Pro Max */
@media only screen and (min-width : 414px) and (max-height : 896px) and (-webkit-device-pixel-ratio : 3) { 
    .btnPlus {
        margin-bottom:80px;
    }
    .btnPlusNew {
        margin-bottom:0px;
    }
}

/* iphone 12 Pro Max */
@media only screen and (min-width : 428px) and (max-height : 926px) and (-webkit-device-pixel-ratio : 3) { 
    .btnPlus {
        margin-bottom:80px;
    }
    .btnPlusNew {
        margin-bottom:0px;
    }
}
</style>